import { useDisplayClearBtn } from 'hooks/useDisplayClearBtn'
import { ListRequestParams } from 'modules/domain/types'
import { FC, useMemo } from 'react'
import { AClearFiltersButton } from 'views/components/Analytics'
import { FiltersAndSearchWrapper, FiltersWrapper } from 'views/components/CommonTableComponents/CommonTableComponents'
import { LogisticianFilter } from '../../components/LogisticianFilter'
import { CommonRegionFilter } from 'views/components/TableFilters/RegionsFilters/CommonRegionFilter'
import { RatesTabTypes } from '../types'
import { useParams } from 'react-router'
import { SearchFilter } from 'views/components/SearchFilter/SearchFilter'
import { ABaseTableFilter } from 'views/components/TableFilters/ABaseTableFilter'
import { endpoints } from 'modules/endpoints'
import { useTranslation } from 'react-i18next'

interface Props {
  listRequestParams: ListRequestParams
  updateFilterState: (filterObj: Record<string, any>) => void
  clearAllTabsState: (defaultParams: Record<string, any>) => void
}

export const roadsInitialParams = {
  filter: { country: '3' },
}

const getDefaultParams = (activeTab: RatesTabTypes) => {
  if ([RatesTabTypes.cereals, RatesTabTypes.oilseeds].includes(activeTab)) {
    return roadsInitialParams
  }
  return { filter: {} }
}

export const RatesFilters: FC<Props> = ({ listRequestParams, updateFilterState, clearAllTabsState }) => {
  const { t } = useTranslation('rates')
  const { activeTab } = useParams() as { activeTab: RatesTabTypes }
  const isRails = [RatesTabTypes.cerealsRails, RatesTabTypes.oilseedsRails].includes(activeTab)
  const isAverage = activeTab === RatesTabTypes.average
  const disableRoadsFilters = isRails || isAverage
  const defaultFilters = useMemo(() => getDefaultParams(activeTab).filter, [activeTab])
  const displayClearBtn = useDisplayClearBtn({
    listRequestParams,
    defaultFilters,
  })

  return (
    <FiltersAndSearchWrapper>
      <FiltersWrapper>
        <CommonRegionFilter
          listRequestParams={listRequestParams}
          updateFilterState={updateFilterState}
          disabled={disableRoadsFilters}
          hideDistrict
        />

        <LogisticianFilter
          listRequestParams={listRequestParams}
          updateFilterState={updateFilterState}
          disabled={disableRoadsFilters}
          fieldKey="logisticians"
          multiple
        />

        {isRails && (
          <ABaseTableFilter
            placeholder={t('common:product')}
            onChange={(product) => updateFilterState({ product })}
            value={listRequestParams.filter.product}
            getLabel={(dto) => dto.name}
            endpoint={`${endpoints.LogisticsKR.products()}?is_etsng_parent=true`}
            showSearch={false}
            multiple
            id="productFilter"
          />
        )}

        {displayClearBtn && <AClearFiltersButton onClick={() => clearAllTabsState(getDefaultParams(activeTab))} />}
      </FiltersWrapper>
      {isRails && <SearchFilter listRequestParams={listRequestParams} updateFilterState={updateFilterState} />}
    </FiltersAndSearchWrapper>
  )
}
